import CenterImage from 'components/common/CenterImage';
import React, { FC } from 'react';
import useCommonStyles from 'styles/common';

import tomato01 from 'assets/stamps/T01.png';
import tomato02 from 'assets/stamps/T02.png';
import tomato03 from 'assets/stamps/T03.png';
import milk01 from 'assets/stamps/M01.png';
import milk02 from 'assets/stamps/M02.png';
import milk03 from 'assets/stamps/M03.png';
import cauli from 'assets/stamps/cauli.svg';
import cx from 'classnames';

interface Props {
    style?: React.CSSProperties;
	className?: string;
}

export const Tomato01: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ tomato01 } alt='tomato' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Tomato02: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ tomato02 } alt='tomato' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Tomato03: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ tomato03 } alt='tomato' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Milk01: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ milk01 } alt='milk' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Milk02: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ milk02 } alt='milk' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Milk03: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ milk03 } alt='milk' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}

export const Cauli: FC<Props> = ({ style, className }) => {
	const common = useCommonStyles();
    return (
        <CenterImage 
			src={ cauli } alt='cauli' className={ cx(common.stampIcon, className) }
			style={ style }
		/>
    )
}
